import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-[#F8FAFC] p-6">
      <div className="w-full max-w-sm">
        <img src="/cass-logo-light.png" alt="CASS" className="h-12 w-auto object-contain mx-auto mb-8" />
        <h1 className="text-2xl font-extrabold text-[#0B1A2F] font-display">Reset password</h1>
        {sent ? (
          <p data-testid="forgot-confirmation" className="text-sm text-slate-600 mt-4">
            If that email is registered, a reset link has been sent. Please check your inbox.
          </p>
        ) : (
          <>
            <p className="text-sm text-slate-500 mt-1 mb-6">Enter your work email and we'll send a reset link.</p>
            <form onSubmit={submit} className="space-y-4">
              <div>
                <Label htmlFor="email">Work email</Label>
                <Input id="email" data-testid="forgot-email-input" type="email" required value={email}
                  onChange={(e) => setEmail(e.target.value)} className="mt-1" />
              </div>
              {error && <p className="text-sm text-rose-600">{error}</p>}
              <Button type="submit" data-testid="forgot-submit-btn" disabled={loading}
                className="w-full bg-[#2EA3FD] hover:bg-[#1B8EE6] text-white font-semibold">
                {loading ? "Sending…" : "Send reset link"}
              </Button>
            </form>
          </>
        )}
        <div className="text-center mt-4">
          <Link to="/login" className="text-sm text-[#2EA3FD] hover:underline">Back to sign in</Link>
        </div>
      </div>
    </div>
  );
}
